
import { props, emptyProps, createAction } from '@ngrx/store';
import type { LoginPayload } from '@fitness-force/models';

export const LOGIN = createAction(
  'LOGIN',
  props<{loginInput:any}>()
);

export const LOGIN_WITH_GOOGLE = createAction(
  'LOGIN_WITH_GOOGLE',
  props<{loginInput:LoginPayload}>()
);
export const LOGIN_SUCCESS = createAction(
  'LOGIN_SUCCESS',
  props<{user:any,token:string,redirect:boolean,auth_response?:any}>()
);
export const LOGIN_FAILED = createAction(
  'LOGIN_FAILED',
  props<{error:any}>()
);







export const AUTO_LOGIN = createAction(
  'AUTO_LOGIN',
  emptyProps
);

// Fired after autoLogin$ completes (success OR failure) — used by guard to avoid race condition
export const AUTO_LOGIN_COMPLETE = createAction(
  'AUTO_LOGIN_COMPLETE',
  emptyProps
);


// TESTING code ...


// STATSIG_INITIALIZE removed - initialization now handled by FeatureFlagService


// for unauthorized ... 
export const STATSIG_UPDATE_USER  = createAction(
  'STATSIG_UPDATE_USER',
  props<{selected_tenant:any}>()
);

export const STATSIG_UPDATE_USER_SUCCESS  = createAction(
  'STATSIG_UPDATE_USER_SUCCESS',
  props<{user:any}>()
);

export const STATSIG_FLAGS_UPDATED = createAction(
  'STATSIG_FLAGS_UPDATED',
  props<{flags: Record<string, boolean>}>()
);

export const SET_USER_THEME  = createAction(
  'SET_USER_THEME',
  emptyProps
);


